/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BucketSchema } from './bucketSchema';

export interface ExperienceStatsSchema {
  avg?: number | null;
  p25?: number | null;
  median?: number | null;
  p75?: number | null;
  histogram?: BucketSchema[];
}
